import { Timer } from '@visiba/std';
import { ControllerContext } from './_controller_context';
import { SocketController } from './socket_controller';
import { Reporter } from './_reporter';

// Socket be like 💻🤝💻 ... 💻🤝💻 ...
export class HandshakeProtocol {
	private static HANDSHAKE_CONTROLLER = 'ping' as const;
	private static HANDSHAKE_MESSAGE = 'ping' as const;

	private interval = new Timer();
	private failedHandshakes = 0;
	private pingController: SocketController | null = null;
	private signed = false;

	public onPanic: (() => void) | null;

	constructor(
		private readonly controllerContext: ControllerContext,
		private readonly reporter: Reporter,
	) {
		this.onPanic = null;
	}

	public sign(checkInterval: number): Timer.Disposer {
		if (this.signed) {
			this.terminate();
		}

		this.reporter.log('Signs handshake protocol');
		this.signed = true;

		this.pingController = this.controllerContext.add(HandshakeProtocol.HANDSHAKE_CONTROLLER);

		return this.interval.repeat(this.handleTick.bind(this), checkInterval);
	}

	public handlePong(): void {
		// Let's figure out a way to log this without spamming the console :)
		// this.reporter.log('[internal] Received pong');

		this.failedHandshakes = 0;
	}

	public terminate(): void {
		if (this.signed) {
			this.reporter.log('Terminates old handshake protocol');
			this.failedHandshakes = 0;
			this.interval.flush();
			this.controllerContext.remove(HandshakeProtocol.HANDSHAKE_CONTROLLER);
			this.signed = false;

			return;
		}
	}

	private handleTick(): void {
		// 😱
		if (this.failedHandshakes > 1) {
			this.reporter.log(`Failed handshakes amount went over 1`);

			this.terminate();

			if (this.onPanic) {
				this.onPanic();
			}

			return;
		}

		// 😊
		this.failedHandshakes++;
		this.pingController?.publish(HandshakeProtocol.HANDSHAKE_MESSAGE);
	}
}
